'use strict';

var translations = {
    warnings: {
        straightRow: 'Уникайте прямих рядків клавіш, таких як "asdf".',
        simpleRepeat: 'Уникайте повторюваних слів і символів, таких як "aaa" і "abcabc".',
        extendedRepeat: 'Уникайте повторюваних слів і символів, таких як "aaa" і "abcabc".',
        sequences: 'Уникайте послідовностей типу "abc" або "6543".',
        recentYears: 'Уникайте останніх років, таких як "2020".',
        dates: 'Уникайте дат.',
        topTen: 'Уникайте поширених паролів.',
        topHundred: 'Уникайте поширених паролів.',
        common: 'Уникайте поширених паролів.',
        similarToCommon: 'Уникайте поширених паролів.',
        wordByItself: 'Уникайте використання одного слова.',
        namesByThemselves: 'Уникайте імен і прізвищ самих по собі.',
        commonNames: 'Уникайте імен і прізвищ самих по собі.',

        userInputs: '',
        pwned: '',
        keyPattern: '',
    },
    suggestions: {
        useWords: 'Використовуйте довгий рядок з більш ніж двома словами; уникайте поширених фраз.',
        anotherWord: 'Додайте ще одне чи два слова. Незвичайні слова краще.',
        repeated: 'Уникайте повторюваних слів і символів, таких як "aaa" і "abcabc".',
        l33t: 'Уникайте передбачуваних замін, таких як "@" замість "a" (наприклад, "@pple" замість "Apple").',
        reverseWords: 'Уникайте перевернутих слів, таких як "elppa" (зворотне від "apple").',
        allUppercase: 'Тільки великі літери майже так само легко вгадати, як і тільки малі літери.',
        dates: 'Уникайте дат.',
        associatedYears: 'Уникайте дат.',
        recentYears: 'Уникайте останніх років, таких як "2020".',
        sequences: 'Уникайте послідовностей типу "abc" або "6543".',

        pwned: '',
        capitalization: '',
        longerKeyboardPattern: '',
        noNeed: '',
    },
    timeEstimation: {
        ltSecond: 'менше секунди',
        second: '{base} секунда',
        seconds: '{base} секунд',
        minute: '{base} хвилина',
        minutes: '{base} хвилин',
        hour: '{base} година',
        hours: '{base} годин',
        day: '{base} день',
        days: '{base} днів',
        month: '{base} місяць',
        months: '{base} місяців',
        year: '{base} рік',
        years: '{base} років',
        centuries: 'століття',
    },
};

export default translations;
//# sourceMappingURL=translations.js.map
